export function Skeleton({ width = "100%", height = 14, radius = 4 }: { width?: number | string; height?: number; radius?: number }) {
  // Dimensions stay inline: they are per-call-site geometry, not a shared token.
  return <div className="skeleton" style={{ width, height, borderRadius: radius }} />;
}

export function SkeletonRows({ rows = 3, height = 14 }: { rows?: number; height?: number }) {
  return (
    <div className="skeleton-stack">
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} height={height} width={i === rows - 1 ? "60%" : "100%"} />
      ))}
    </div>
  );
}
